package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.LocationOutline: ImageVector
    get() {
        if (_locationOutline != null) {
            return _locationOutline!!
        }
        _locationOutline = Builder(name = "LocationOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 16.0f, viewportHeight = 16.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(7.79f, 7.8045f)
                curveTo(8.2056f, 7.8045f, 8.5606f, 7.6573f, 8.8549f, 7.3629f)
                curveTo(9.1493f, 7.0686f, 9.2964f, 6.7137f, 9.2964f, 6.298f)
                curveTo(9.2964f, 5.8825f, 9.1493f, 5.5275f, 8.8549f, 5.2332f)
                curveTo(8.5606f, 4.9388f, 8.2056f, 4.7916f, 7.79f, 4.7916f)
                curveTo(7.3744f, 4.7916f, 7.0195f, 4.9388f, 6.7251f, 5.2332f)
                curveTo(6.4308f, 5.5275f, 6.2836f, 5.8825f, 6.2836f, 6.298f)
                curveTo(6.2836f, 6.7137f, 6.4308f, 7.0686f, 6.7251f, 7.3629f)
                curveTo(7.0195f, 7.6573f, 7.3744f, 7.8045f, 7.79f, 7.8045f)
                lineTo(7.79f, 7.8045f)
                moveTo(7.79f, 14.1779f)
                curveTo(9.4204f, 12.7185f, 10.668f, 11.3186f, 11.5328f, 9.9783f)
                curveTo(12.3977f, 8.6381f, 12.8301f, 7.4642f, 12.8301f, 6.4567f)
                curveTo(12.8301f, 4.9375f, 12.3475f, 3.6885f, 11.3822f, 2.7099f)
                curveTo(10.4169f, 1.7313f, 9.2195f, 1.242f, 7.79f, 1.242f)
                curveTo(6.3605f, 1.242f, 5.1632f, 1.7313f, 4.1979f, 2.7099f)
                curveTo(3.2326f, 3.6885f, 2.75f, 4.9375f, 2.75f, 6.4567f)
                curveTo(2.75f, 7.4642f, 3.1824f, 8.6381f, 4.0472f, 9.9783f)
                curveTo(4.9121f, 11.3186f, 6.1597f, 12.7185f, 7.79f, 14.1779f)
                lineTo(7.79f, 14.1779f)
                moveTo(7.79f, 15.8413f)
                curveTo(5.6928f, 14.024f, 4.1202f, 12.3328f, 3.0721f, 10.7676f)
                curveTo(2.024f, 9.2024f, 1.5f, 7.7655f, 1.5f, 6.4567f)
                curveTo(1.5f, 4.5336f, 2.1221f, 2.9767f, 3.3662f, 1.786f)
                curveTo(4.6103f, 0.5954f, 6.0849f, 0.0f, 7.79f, 0.0f)
                curveTo(9.4952f, 0.0f, 10.9698f, 0.5954f, 12.2139f, 1.786f)
                curveTo(13.458f, 2.9767f, 14.0801f, 4.5336f, 14.0801f, 6.4567f)
                curveTo(14.0801f, 7.7655f, 13.556f, 9.2024f, 12.508f, 10.7676f)
                curveTo(11.4599f, 12.3328f, 9.8872f, 14.024f, 7.79f, 15.8413f)
                lineTo(7.79f, 15.8413f)
                moveTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
                lineTo(7.79f, 6.298f)
            }
        }
        .build()
        return _locationOutline!!
    }

private var _locationOutline: ImageVector? = null
